import ScreenTitle from "./ScreenTitle";
export default ScreenTitle;
